import React, { useState, useEffect } from 'react';

import PopulationContent from 'components/SocialSurvey/SocialEconomicData/PopulationContent';
import EconomyAndIndustryContent from 'components/SocialSurvey/SocialEconomicData/EconomyAndIndustryContent';

import TagTab from 'components/TagTab';

import town from 'data/changhua_town_geo.json';

import { BE_URL } from 'utils/config';

function TownContent() {
  const [filter, setFilter] = useState({
    tag: 'population',
  });
  const [townPopulationData, setTownPopulationData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await fetch(
          `${BE_URL}/api/social-economic-population-data/?scale=town`
        );
        if (!res.ok) throw new Error('Network response was not ok');
        const data = await res.json();
        setTownPopulationData(data);
      } catch (error) {
        console.error('載入 villagePopulationData 失敗:', error);
      } finally {
        setLoading(false);
      }
    }

    fetchData();
  }, []);

  const tabList = [
    {
      id: 'population',
      title: '人口概況',
      content: (
        <PopulationContent
          scale="town"
          rawData={townPopulationData}
          map={town}
          filter={filter}
        />
      ),
    },
    {
      id: 'economy-and-industry',
      title: '經濟與產業',
      content: <EconomyAndIndustryContent filter={filter} />,
    },
  ];

  if (loading) {
    return <div>資料載入中...</div>;
  }

  return (
    <>
      <article className="l-social-economy-data">
        <TagTab list={tabList} filter={filter} setFilter={setFilter} />
        {tabList.find((item) => item.id === filter.tag).content}
      </article>
    </>
  );
}

export default TownContent;
